import React from 'react';
import { Link } from 'react-router-dom';

const ForumBanner = () => {
  return (
    <section className="forum_banner">
      <h2>ドナー募集掲示板</h2>
      <p>ドニーが条件を投稿し、ドナーが応募する新しいマッチングフローです。<Link to="/forum_about">もっと詳しく</Link></p>
      <Link to="/forum" className="pinkbtn">掲示板を見る</Link>
    </section>
  );
};

export default ForumBanner;
